module.exports = __webpack_public_path__ + "img/Presentation14.de04a289.png";